import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import "./CategoriesModeVideo.scss";

import {LoadingBar} from "../../../../../components/Loader";
import {
    fetchCategoriesModeVideo,
    resetCategoriesModeVideo
} from "../../../../../../creators/tagModerations.categoriesModeVideo";
import pictureVideoCameraAlt from "../../images/video-camera-alt.png";
import Icon from "../../../../../components/Icon";
import {Link} from "react-router-dom";


class CategoriesModeVideo extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }

        this.titleToClass={
            'Vidéos de moins de 30 secondes' : 'small',
            'Vidéos de 30 secondes à 2 minutes' : 'medium',
            'Vidéos de plus de 2 minutes' : 'large'
        };
        this.titleToShortTitle={
            'Vidéos de moins de 30 secondes' : '- de 30s',
            'Vidéos de 30 secondes à 2 minutes' : '+ de 30s',
            'Vidéos de plus de 2 minutes' : '+ de 2 min'
        }
        this.props.resetCategoriesModeVideo();
        this.props.fetchCategoriesModeVideo();
    }
/*
    componentWillUnmount() {
        this.props.resetCategoriesModeVideo();
    }
*/

    render() {

        let categoriesModeVideo = this.props.categoriesModeVideo.filter(category => category.totalModeration > 0);
        let isShowVideo = categoriesModeVideo.length > 0;
        /*return !this.props.categoriesModeVideoInitialized ? <LoadingBar /> : (
            <div className={`categories-video ${categoriesModeVideo.length === 0 ? "hidden" : ""}`}>
                <div className={`category-title ${this.props.displayCategory === "modevideo" ? "open" : ""}`} onClick={()=> this.props.handleDisplayCategory(this.props.displayCategory === "modevideo" ? "" : "modevideo")}>Vidéos</div>
                <div className={`categories ${this.props.displayCategory === "modevideo" ? "active" : ""}`}>
                    {categoriesModeVideo.map(category =>(
                            <Button
                                key={category._id}
                                className="btn-category"
                                btnStyle={"primary"}
                                size={"small"}
                                content={`${category.title} ( ${category.totalModeration || 0} medias)`}
                                onClick={() => {history.push(`${this.props.currentUrl}-video/${category._id.toString()}`)}}
                            />
                        )
                    )}
                </div>

            </div>
        )*/
        return isShowVideo ? (
            <section id="pict-gender">
                <div className="taggage-media-main-content-title">
                    <img src={pictureVideoCameraAlt} alt="" />
                    <h1>Visionner et catégoriser les vidéos</h1>
                </div>

                <p className="taggage-media-main-content-description">Choisissez l'image de couverture
                    la plus adaptée puis visionnez la vidéo pour sélectionner les tags
                    correspondants.</p>
                {!this.props.categoriesModeVideoInitialized ? <LoadingBar /> : (
                <div className="taggage-media-main-content-play">
                    {categoriesModeVideo.map(category =>(
                        <div key={category._id} className={`taggage-media-main-content-play-chrono small ${this.titleToClass[category.title] || ""}`}>
                            <div className="taggage-media-main-content-play-chrono-time">
                                <Icon type={"stop-watch"} className={"taggage-media-main-content-play-chrono-time-icon"} />
                                <p>{this.titleToShortTitle[category.title] || ""}</p>
                            </div>
                            <Link to={`${this.props.currentUrl}-video/${category._id.toString()}`} className="count-media-cta">
                                <div className="count-media">
                                    <Icon type={"picture-2"} size={"w-20"} className={"mr-4"} />
                                    <p>{category.totalModeration || 0}<br /><span>médias</span></p>
                                </div>
                                <Icon type={"arrow-right-2"} size={"w-20"} className={"mr-4"} />
                            </Link>
                        </div>
                    ))}
                </div>)}
            </section>
        ) : null
    }
}

const mapStateToProps = (state) => {
    return {
        categoriesModeVideo: state.categoriesModeVideo.data,
        categoriesModeVideoInitialized : state.categoriesModeVideo.initialized,
        categoriesModeVideoLoading : state.categoriesModeVideo.loading
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchCategoriesModeVideo,
    resetCategoriesModeVideo
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CategoriesModeVideo);